import { Col, Layout, Row } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import EstimateSection from './EstimateSection/EstimateSection';
import ImageGallery from './image-gallery';
import { WhatToExpect } from './what-to-expect';

import './order-summary-page.scss';

const { Sider } = Layout;

interface OrderSummaryPageProps {
    onClose: () => void;
    isHidden?: boolean;
}

const OrderSummaryPage = ({ onClose, isHidden = false }: OrderSummaryPageProps): JSX.Element => {
    const [agreementSelected, setAgreementSelected] = useState(false);
    const [showCustomerExpecationModal, setShowCustomerExpecationModal] = useState(false);
    const { t } = useTranslation();

    if (isHidden) {
        return <></>;
    }

    return (
        <div className="order-summary">
            <h1>{t('ORDER_SUMMARY.ESTIMATE_SECTION.PAGE_TITLE')}</h1>
            <br />
            <Row gutter={[10, 10]}>
                <Col xs={24} lg={16}>
                    <Row gutter={[10, 10]}>
                        <Col xs={24}>
                            <div className="image-gallery-grid">
                                <ImageGallery onClose={onClose} />
                            </div>
                        </Col>
                        <Col xs={0} lg={24}>
                            <div className="what-to-expect-grid">
                                <WhatToExpect />
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col xs={24} lg={8}>
                    <Sider className="estimate-section-grid" theme="light" width="100%" reverseArrow={false}>
                        <EstimateSection
                            onClose={onClose}
                            agreementSelected={agreementSelected}
                            setAgreementSelected={setAgreementSelected}
                            showCustomerExpecationModal={showCustomerExpecationModal}
                            setShowCustomerExpecationModal={setShowCustomerExpecationModal}
                        />
                    </Sider>
                </Col>
            </Row>
        </div>
    );
};
export default OrderSummaryPage;
